import type { SettingsSubComponentProps } from '@carboncopyco/components';
import {
  DemoUrlDisplay,
  SettingMainItemsKeys,
  SettingsSubKeys,
} from '@carboncopyco/types/desktop/appSettings';
import {
  RadioGroup,
  Separator,
  TextBase,
  TextCaption,
  Toggle,
} from '@carboncopyco/ui';
import { useBoolean } from 'ahooks';
import { useState } from 'react';
import { HeaderBlock } from './HeaderBlock';

const radios = [
  {
    label: 'Only domain',
    id: DemoUrlDisplay.only_domain,
    value: DemoUrlDisplay.only_domain,
    component: <TextCaption label="ex. Revpower.io" />,
  },
  {
    label: 'Full URL',
    id: DemoUrlDisplay.full,
    value: DemoUrlDisplay.full,
    component: (
      <TextCaption label="ex. http://revpower.io/homepage/analytics" />
    ),
  },
  {
    label: 'Hide URL from display',
    id: DemoUrlDisplay.hide,
    value: DemoUrlDisplay.hide,
    component: <TextCaption label="No URL" />,
  },
];

const AssetPresentation = ({
  saveData,
  getValue,
}: SettingsSubComponentProps) => {
  const [selected, setSelected] = useState(
    getValue(SettingsSubKeys.DemoUrlDisplay)
  );
  const [isSpeakerDisplay, { toggle: toggleSpeakerDisplay }] = useBoolean(
    getValue(SettingsSubKeys.ShowSpeakerPanelByDefault)
  );
  return (
    <div className="flex flex-col grow">
      <HeaderBlock
        label={SettingMainItemsKeys.PresentationDisplay}
        description="Display settings for asset presentation."
      />
      <div className="flex-col flex gap-2.5 pr-7">
        <TextBase
          label="Set URL display for demo "
          color="text-ds-natural-600"
        />
        <div>
          <RadioGroup
            radios={radios}
            onChange={(value) => {
              saveData(SettingsSubKeys.DemoUrlDisplay, value, setSelected);
            }}
            defaultValue={selected}
            value={selected}
          />
        </div>
        <div className="flex flex-col">
          <div className="flex-col flex pb-2.5 ">
            <div className="flex py-8 -mr-7">
              <Separator horizontal />
            </div>
            <TextBase
              label="Speaker panel"
              color="text-ds-natural-600"
            />
          </div>
          <div className="flex flex-col ">
            <div className="flex w-full items-center justify-between">
              <div>
                <TextBase
                  label="Open speaker panel by default"
                  color="text-ds-natural-600"
                />
              </div>
              <div>
                <Toggle
                  testId="speakerPanelToggle"
                  checked={isSpeakerDisplay}
                  onChange={() => {
                    saveData(
                      SettingsSubKeys.ShowSpeakerPanelByDefault,
                      !isSpeakerDisplay,
                      toggleSpeakerDisplay
                    );
                  }}
                />
              </div>
            </div>
            <TextCaption label="Remember, only you can see it." />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetPresentation;
